import { KnobConfig } from './../panel-charts/chart-configuration-models/knob-config';
import { TreeMapConfig } from './../panel-charts/chart-configuration-models/treeMap-config';
import { EdaBlankPanelComponent } from '../eda-blank-panel.component';
import { ChartConfig } from '../panel-charts/chart-configuration-models/chart-config';
import { ChartJsConfig } from '../panel-charts/chart-configuration-models/chart-js-config';
import { KpiConfig } from '../panel-charts/chart-configuration-models/kpi-config';
import { DynamicTextConfig } from '../panel-charts/chart-configuration-models/dynamicText-config';
import { MapConfig } from '../panel-charts/chart-configuration-models/map-config';
import { SankeyConfig } from '../panel-charts/chart-configuration-models/sankey-config';
import { FunnelConfig } from '../panel-charts/chart-configuration-models/funnel.config';

import { TableConfig } from '../panel-charts/chart-configuration-models/table-config';
import { ScatterConfig } from '../panel-charts/chart-configuration-models/scatter-config';
import { SunburstConfig } from '../panel-charts/chart-configuration-models/sunburst-config';
import { BubblechartConfig } from '../panel-charts/chart-configuration-models/bubblechart.config';
import { TreeTableConfig } from '../panel-charts/chart-configuration-models/treeTable-config';

export const ChartsConfigUtils = {

  setConfig: (ebp: EdaBlankPanelComponent) => {
    let tableRows: number;
    let config: any = null;

    if (!ebp.panelChart) {
      return new ChartConfig(config);
    }


    if (ebp.panelChart.componentRef && ['table', 'crosstable'].includes(ebp.panelChart.props.chartType)) {
      tableRows = ebp.panelChart.componentRef.instance.inject.rows || 10;
      config = {
        chartType: ebp.panelChart.props.chartType,
        withColTotals: ebp.panelChart.componentRef.instance.inject.withColTotals,
        withColSubTotals: ebp.panelChart.componentRef.instance.inject.withColSubTotals,
        withRowTotals: ebp.panelChart.componentRef.instance.inject.withRowTotals,
        withTrend: ebp.panelChart.componentRef.instance.inject.withTrend,
        resultAsPecentage: ebp.panelChart.componentRef.instance.inject.resultAsPecentage,
        onlyPercentages: ebp.panelChart.componentRef.instance.inject.onlyPercentages,
        visibleRows: tableRows,
        sortedSerie: ebp.panelChart.componentRef.instance.inject.sortedSerie,
        sortedColumn: ebp.panelChart.componentRef.instance.inject.sortedColumn,
        styles: ebp.panelChart.componentRef.instance.inject.styles,
        noRepetitions: ebp.panelChart.componentRef.instance.inject.noRepetitions,
        negativeNumbers: ebp.panelChart.componentRef.instance.inject.negativeNumbers,
        ordering: ebp.panelChart.componentRef.instance.inject.ordering,
      }

    } else if (ebp.panelChart.componentRef && ebp.panelChart.props.chartType.includes('kpi')) {
      const kpiChart = ebp.panelChart.componentRef.instance.inject?.edaChart;

      config = {
        sufix: ebp.panelChart.componentRef.instance.inject.sufix,
        alertLimits: ebp.panelChart.componentRef.instance.inject.alertLimits,
        assignedColors: ebp.panelChart.props.config?.getConfig()?.['assignedColors'] || null,
        modifiedFontPoints: ebp.panelChart.componentRef.instance.inject.modifiedFontPoints || 0,
        backgroundColor: ebp.panelChart.componentRef.instance.inject.backgroundColor || '',
        kpiColor: ebp.panelChart.componentRef.instance.inject.kpiColor || '',
        prefixImage: ebp.panelChart.componentRef.instance.inject.prefixImage || '',
        edaChart: {}
      }

      if (kpiChart?.hasOwnProperty('edaChart')) {
        config.edaChart.colors = kpiChart.chartColors;
        config.edaChart.chartType = ebp.panelChart.props.chartType;
        config.edaChart.assignedColors = ebp.panelChart.props.config?.getConfig()?.['assignedColors'] || null;  // ambién en edaChart
      }
    } else if (ebp.panelChart.componentRef && ebp.panelChart.props.chartType === 'dynamicText') {
      const dtInstance = ebp.panelChart.componentRef.instance;
      config = {
        color: dtInstance ? dtInstance.inject.color : ebp.panelChart.props.config.getConfig()['color'],
        modifiedFontPoints: dtInstance ? (dtInstance.inject.modifiedFontPoints || 0) : (ebp.panelChart.props.config.getConfig()['modifiedFontPoints'] || 0)
      }
    } else if (ebp.panelChart.props.chartType === 'geoJsonMap') {
      config = {
        zoom: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.zoom : null,
        coordinates: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.coordinates : null,
        logarithmicScale: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.logarithmicScale : null,
        baseLayer: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.baseLayer : null,
        legendPosition: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.legendPosition : null,
        assignedColors: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.assignedColors : null,
        draggable: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.draggable : null,
      }
    } else if (ebp.panelChart.props.chartType === 'treetable') {
      config = {
        chartType: ebp.panelChart.props.chartType,
        editedTreeTable: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['editedTreeTable'] : false,
        hierarchyLabels: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['hierarchyLabels'] : [],
        leafLabels: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['leafLabels'] : [],
      }

    } else if (ebp.panelChart.props.chartType === 'coordinatesMap') {
      config = {
          zoom: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.zoom : null,
          coordinates: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.coordinates : null,
          logarithmicScale: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.logarithmicScale : null,
          assignedColors: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.assignedColors : null,
          draggable: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.inject.draggable : null,
      }
    } else if (["parallelSets", "treeMap", "scatterPlot", "funnel", "bubblechart", "sunbursts"].includes(ebp.panelChart.props.chartType)) {
      config = {
        assignedColors: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.assignedColors : [],
      }
    } else if (ebp.panelChart.props.chartType === 'knob') {

      config = {
        assignedColors: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.assignedColors : ebp.panelChart.props.config.getConfig()['assignedColors'],
        limits: ebp.panelChart.componentRef ? ebp.panelChart.componentRef.instance.limits : ebp.panelChart.props.config.getConfig()['limits']
      };
    } else {
      // Chart.js
      config = {
        chartType: ebp.panelChart.props.chartType,
        addTrend: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['addTrend'] : false,
        addComparative: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['addComparative'] : false,
        showLabels: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['showLabels'] : false,
        showLabelsPercent: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['showLabelsPercent'] : false,
        showPointLines: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['showPointLines'] : false,
        showPredictionLines: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['showPredictionLines'] : false,
        numberOfColumns: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['numberOfColumns'] : null,
        assignedColors: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['assignedColors'] : [], // o null?
        chartLegend: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['chartLegend'] ?? true : true,
        coloredBarsConfig: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['coloredBarsConfig'] : null,
        showUniqueColors: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['showUniqueColors'] : null,
        uniqueBarColors: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['uniqueBarColors'] : null,
        showGridLines: ebp.panelChart.props.config && ebp.panelChart.props.config.getConfig() ? ebp.panelChart.props.config.getConfig()['showGridLines'] ?? true : true
      };
    }

    return new ChartConfig(config);
  },

    /**
    * Returns a configuration object for this type
    * @param type chart type
    */
    setVoidChartConfig: (type: string) => {
        if (['table', 'crosstable'].includes(type)) {
          return new TableConfig(false, false, 10, false, false, false, false, null, null, null, false, false ,  []);
        }else if (['bar', 'line', 'area', 'pie', 'doughnut', 'polarArea', 'barline', 'horizontalBar', 'pyramid', 'histogram', 'radar'].includes(type)) {
            return new ChartJsConfig(null, type, false, false, false, false, null,[], false, false);
        } else if (type === 'parallelSets') {
            return new SankeyConfig([]);
        } else if (type === 'treeMap') {
            return new TreeMapConfig([]);
        } else if(type === 'treetable') {
          return new TreeTableConfig(false, [], []);
        } else if (type === 'scatterPlot') {
            return new ScatterConfig([]);
        } else if (type === 'funnel') {
            return new FunnelConfig([]);
        } else if (type === 'bubblechart') {
            return new BubblechartConfig([]);
        } else if (type === 'knob') {
            return new KnobConfig(null, null);
        } else if (type === 'sunburst') {
            return new SunburstConfig([]);
        } else if (type === 'kpi') {
            return new KpiConfig();
        } else if (['kpibar', 'kpiline', 'kpiarea'].includes(type)) {
            return new KpiConfig({
                edaChart:  new ChartJsConfig(null, type, false, false, false, false, null,[], false, false)
            });
        } else if (type === 'dynamicText') {
            return new DynamicTextConfig(null);
        }
    },

  recoverConfig: (type: string, config: TableConfig | KpiConfig | DynamicTextConfig | ChartJsConfig | MapConfig | SankeyConfig | TreeMapConfig | TreeTableConfig | KnobConfig | FunnelConfig | BubblechartConfig |SunburstConfig) => {

    return new ChartConfig(config);

  }




}